import React, { useState, useEffect } from "react";
/** Components Import */
import { DropdownButton, Dropdown as btDropdown } from "react-bootstrap";

function Dropdown({
  className = "",
  itemClassName = "",
  variant = "primary", // 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link'
  directions = "down", // 'up', 'up-centered', 'down', 'down-centered', 'start', 'end'
  size = "md", // 'sm', 'md', 'lg'
  disabled = false,
  title = "",
  items = [],
  onChange = (e) => {},
}) {
  const [dropdownTitle, setDropdownTitle] = useState(title);

  useEffect(() => {
    setDropdownTitle(title);
  }, [items]);

  const ChangeTitle = (e) => {
    setDropdownTitle(e.target.textContent);
  };

  const ChangeDropdown = (e) => {
    onChange(e);
  };

  return (
    <DropdownButton
      className={`${className} custom-dropdown-button`}
      variant={variant}
      drop={directions}
      size={size}
      title={dropdownTitle}
      disabled={disabled}
      onSelect={ChangeDropdown}
    >
      {items.map((item, index) => {
        return (
          <btDropdown.Item
            key={index}
            className={`${itemClassName}`}
            disabled={item.disabled}
            eventKey={item.value}
            onClick={ChangeTitle}
          >
            {item.text}
          </btDropdown.Item>
        );
      })}
    </DropdownButton>
  );
}

export default Dropdown;
